import Immutable, { Record, List } from 'immutable';

import SkillAbility from './abilities';
import OverallDevelopmentItem from './items';

const OverallDevelopmentSkillRecord = Record({
  id: undefined,
  name: undefined,
  items: new List(),
  abilities: new List(),
});

class OverallDevelopmentSkill extends OverallDevelopmentSkillRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'id':
      return [key, `${val}`];
    case 'items':
      return [key, new List(val.map(OverallDevelopmentItem.create))];
    case 'abilities':
      return [key, new List(val.map(SkillAbility.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

OverallDevelopmentSkill.create = (data) =>
  new OverallDevelopmentSkill(data).mapEntries(reviver);

export default OverallDevelopmentSkill;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/skills/model.js